
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hero-pdp/[[...heroPDPSlug]]",
      function () {
        return require("private-next-pages/hero-pdp/[[...heroPDPSlug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hero-pdp/[[...heroPDPSlug]]"])
      });
    }
  